/**
 * Please don't sort offers
 * By sorting we get offers for the first month on the Payment pages
 * Object.values(constants.discountCoupons).slice(0, -2)
 */
const discountCoupons = {
  '15_off'         : 'HDR15',        // discount coupon for first month
  '20_off'         : 'HDR20',        // discount coupon for first month
  '25_off'         : 'HD25',         // discount coupon for first month
  '30_off'         : '30HDR',        // discount coupon for first month
  '50_off'         : 'HDR50',        // discount coupon for first month
  off30Influencer  : 'HDR30INF',     // discount coupon for first month
  fivemonthdiscount: 'SUBFOR13505MONTHS',
  freeTrial        : 'FREE_TRIAL',
  freeTrial7       : 'FREE_TRIAL_7',
  '2items70'       : '2ITEMS70',
  '2items25'       : '2ITEMS25',
  '3items25'       : '3ITEMS25',
}


export default discountCoupons
